import { Typography } from "@mui/material";
import DoctorUserIcon from "../../../../assets/svgs/DoctorUserIcon";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import { DoctorGC } from "../../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/DoctorGC";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";

const DoctorCard: React.FC<{ handleButtonClick: () => void, doctor: DoctorGC }> = ({ handleButtonClick, doctor }) => {

  const accessibility = useAccessibility();

  return (
    <div className='doctos-card-holder' style={accessibility.contrastStyle}>
      <div className="doctors-card-icon">
        <DoctorUserIcon />
      </div>
      <div className="doctors-card-info">
        <h1 className='doctors-name' style={accessibility.textStyleAccessibility}>{doctor.nome}</h1>
        <span className='doctors-info' style={accessibility.textStyleAccessibility}><b>Especialidade:</b> {doctor.descrEspec}</span>
        <div>
          <DefaultButton onClick={handleButtonClick} aria-label={`Agendar com ${doctor.nome}, ${doctor.descrEspec}`}>
            <Typography style={accessibility.textStyleAccessibility} fontFamily={'UnimedSans-Bold'}>
              Agendar
            </Typography>
          </DefaultButton>
        </div>
      </div>
    </div>
  )
}

export default DoctorCard;